import { Component, Prop } from '@stencil/core';

@Component({
  tag: 'cwru-colors',
  styleUrl: 'colors.css',
  shadow: true,
})

export class ColorList {
  @Prop() colorName:  string;
  @Prop() colorHex: string;
}
